import React, { useState } from 'react';
import { UnifiedFacilityManagement } from './UnifiedFacilityManagement';
import { FacilityProfileView } from './FacilityProfileView';

interface FacilitiesSectionProps {
  isDemo?: boolean;
  canAddFacility?: boolean;
}

export const FacilitiesSection: React.FC<FacilitiesSectionProps> = ({ 
  isDemo = false,
  canAddFacility = true
}) => {
  const [selectedFacility, setSelectedFacility] = useState<any>(null);

  // If a facility is selected, show its profile
  if (selectedFacility) {
    return (
      <FacilityProfileView
        facility={selectedFacility}
        onBack={() => setSelectedFacility(null)}
        isDemo={isDemo}
      />
    );
  }

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-semibold">Facilities Management</h2>
        <p className="text-sm text-muted-foreground">Manage your facilities</p>
      </div>
      <UnifiedFacilityManagement 
        isDemo={isDemo} 
        canAddFacility={canAddFacility}
        onSelectFacility={(facility) => setSelectedFacility(facility)}
      />
    </div>
  );
};

export default FacilitiesSection;
